import { useTranslation } from "react-i18next";
import { Archive, Pencil } from "lucide-react";
import type { Package } from "@nh/shared";
import { Button } from "@/shared/ui/core";

export interface PackageRowActionsProps {
  pkg: Package;
  name: string;
  onEdit: (pkg: Package) => void;
  onArchive: (pkg: Package) => void;
  /** `true` mientras se archiva ESTE paquete. */
  archiving?: boolean;
}

/**
 * Las acciones de una fila: editar y archivar.
 *
 * No hay "eliminar" y no es un olvido. Un paquete se cobra MES CON MES:
 * borrarlo deja cada suscripción viva apuntando a un id que ya no
 * existe, y con él el precio congelado al contratar y los VP que otorga.
 * Archivar lo saca del catálogo y lo deja entero para quien ya lo tiene.
 *
 * Los botones llevan el NOMBRE del paquete en su `aria-label`: en una
 * tabla, varios botones que se llaman "Editar" son indistinguibles para
 * quien navega por lista de controles.
 */
export function PackageRowActions({
  pkg,
  name,
  onEdit,
  onArchive,
  archiving = false,
}: PackageRowActionsProps) {
  const { t } = useTranslation();
  const isArchived = pkg.status === "archived";

  return (
    <div className="flex items-center justify-end gap-1.5">
      <Button
        variant="ghost"
        size="sm"
        iconOnly
        leftIcon={<Pencil />}
        aria-label={`${t("Editar")}: ${name}`}
        onClick={() => onEdit(pkg)}
      />
      <Button
        variant="ghost"
        size="sm"
        iconOnly
        leftIcon={<Archive />}
        loading={archiving}
        disabled={isArchived}
        aria-label={`${t("Archivar")}: ${name}`}
        title={isArchived ? t("Ya está archivado") : t("Archivar")}
        onClick={() => onArchive(pkg)}
      />
    </div>
  );
}
